import AWS from 'aws-sdk';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';

const {
  REACT_APP_AWS_S3_ENDPOINT,
  REACT_APP_AWS_S3_REGION,
  REACT_APP_AWS_S3_ACCESS_ID,
  REACT_APP_AWS_S3_SECRET_SUCCESS_KEY,
} = process.env;

const s3 = new AWS.S3({
  endpoint: String(REACT_APP_AWS_S3_ENDPOINT),
  region: String(REACT_APP_AWS_S3_REGION),
  credentials: {
    accessKeyId: REACT_APP_AWS_S3_ACCESS_ID
      ? String(REACT_APP_AWS_S3_ACCESS_ID)
      : '',
    secretAccessKey: REACT_APP_AWS_S3_SECRET_SUCCESS_KEY
      ? String(REACT_APP_AWS_S3_SECRET_SUCCESS_KEY)
      : '',
  },
  s3ForcePathStyle: true,
});

export const getS3Object = async (bucketName: string, objectKey: string) => {
  const params = {
    Bucket: bucketName,
    Key: objectKey,
    ResponseCacheControl: 'no-cache',
  };

  try {
    const data = await s3.getObject(params).promise();
    return data.Body;
  } catch (error) {
    console.error('Error retrieving object:', error);
    throw error;
  }
};

export const getS3ObjectMimeType = async (bucketName: string, objectKey: string) => {
  const params = {
    Bucket: bucketName,
    Key: objectKey,
  };

  try {
    const data = await s3.headObject(params).promise();
    return data.ContentType;
  } catch (error) {
    console.error('Error retrieving object content type:', error);
    throw error;
  }
};

export const getS3AvatarPresignedUrl = async (fileName: any): Promise<any> => {
  try {
    const response: any = await jwtAxios.get(
      `/user/image/presigned-url/${fileName}`,
    );
    return response?.data?.url;
  } catch (error) {
    console.error('Error retrieving object:', error);
    throw error;
  }
};
